module.exports = __webpack_public_path__ + "static/partner-4-5459cbea3897987c4eb5f58820f284d5.png";